import { getUserLocaleVocabularyByLocale } from './localization.utils';

export const getLocalizationInitialState = () => ({
  data: {
    locale: navigator.language,
    translations: getUserLocaleVocabularyByLocale(),
  },
  isLoading: false,
  error: null,
});
